module.exports = __webpack_public_path__ + "static/media/discountCodesIcon.68508a22.svg";